// @todo: Migrate to 'Pill' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Pill} from '@wandb/weave/components/Tag';
import {Tailwind} from '@wandb/weave/components/Tailwind';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TooltipDeprecated} from '@wandb/weave/components/TooltipDeprecated';
import React from 'react';

import {WeaveRoleType} from './util';

type WeaveRoleTypeProps = {
  currentWeaveRole: WeaveRoleType | undefined;
  isEnterprisePlan?: boolean;
};

export const WeaveRoleTypePill = ({
  currentWeaveRole: currentWeaveRole,
  isEnterprisePlan = false,
}: WeaveRoleTypeProps) => {
  if (!currentWeaveRole) {
    return null;
  }

  const PillComponent = (
    <Pill
      label={currentWeaveRole}
      icon={
        currentWeaveRole === WeaveRoleType.VIEWER
          ? 'show-visible'
          : 'checkmark-circle'
      }
      color="teal"
    />
  );

  return (
    <Tailwind>
      {currentWeaveRole === WeaveRoleType.NOACCESS ? (
        <span className="text-gray-450 ">{currentWeaveRole}</span>
      ) : isEnterprisePlan ? (
        <TooltipDeprecated
          position="top center"
          className="flex items-center"
          trigger={<div>{PillComponent}</div>}>
          <Tailwind>
            <div className="flex items-center">
              Change organization role to change access
            </div>
          </Tailwind>
        </TooltipDeprecated>
      ) : (
        <div>{PillComponent}</div>
      )}
    </Tailwind>
  );
};
